
import React from 'react';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import useAuthIsAccountActivated from '../../common/client/hooks/mysliveckyportal/useAuthIsAccountActivated';
import useAuthToken from '../../common/client/hooks/mysliveckyportal/useAuthToken';
import useArticles from '../../hooks/useArticles';
import IfComp from '../../common/client/components/IfComp';
import AppPageStyle from '../../common/client/components/mysliveckyportal/AppPageStyle';

import useNavigationItems  from '../../hooks/useNavigationItems';
import CheckUserAccountActivation from '../../components/auth/CheckUserAccountActivation';
import LoginInfo from '../../components/auth/LoginInfo';
import ArticleList from '../../components/articles/ArticleList';
import TileContent from '../../components/tiles/TileContent';
import TileHonitbaKey from '../../components/tiles/TileHonitbaKey';
import TileWebHonitba from '../../components/tiles/TileWebHonitba';
import TileContacts from '../../components/tiles/TileContacts';

const classNames = mergeStyleSets({
    HomePage: {
    },
    grid: {
        padding: 8,
    },
    grid11: {
        width: '50%',
    },
    grid12: {
        width: '50%',
    },
});

const HomePage = (props) => {

    const activated = useAuthIsAccountActivated();
    const token = useAuthToken();
    const articles = useArticles();
    const navigationItems = useNavigationItems();

    const getActualArticle = (articles) => {
        return (articles && articles.length && articles.length > 0)
            ? [articles[0]]
            : [];
    }

    return (
        <AppPageStyle
            appHeaderContent={<LoginInfo />}
            navigationItems={navigationItems}
            page="home"
        >
            <Stack className={classNames.HomePage}>
                <CheckUserAccountActivation />
                <Stack className={classNames.grid}>
                    <Stack horizontal>
                        <Stack.Item className={classNames.grid11}>
                            <Stack>
                                <TileWebHonitba
                                    token={token}
                                    activated={activated}
                                />
                                <TileHonitbaKey />
                            </Stack>
                        </Stack.Item>
                        <Stack.Item className={classNames.grid12}>
                            <TileContent title="Nejnovější článek">
                                <IfComp cond={articles && articles.length && (articles.length > 0)}>
                                    <ArticleList
                                        articles={getActualArticle(articles)}
                                    />
                                </IfComp>
                            </TileContent>
                        </Stack.Item>
                    </Stack>
                    <TileContacts />
                </Stack>
            </Stack>
        </AppPageStyle>
    );
}

export default HomePage;
